<template>
  <v-card class="pa-4" elevation="3">
    <v-card-title class="text-h6 font-weight-bold">إحصائيات الاستبيان</v-card-title>

    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-sheet class="pa-3 bg-grey-lighten-3 text-center rounded-lg">
          <div class="font-weight-bold">تم الإرسال إلى</div>
          <div class="text-h5">{{ stats.sentCount }}</div>
        </v-sheet>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-sheet class="pa-3 bg-light-blue-lighten-4 text-center rounded-lg">
          <div class="font-weight-bold">عدد الاستجابة</div>
          <div class="text-h5">{{ stats.openedCount }}</div>
        </v-sheet>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-sheet class="pa-3 bg-amber-lighten-4 text-center rounded-lg">
          <div class="font-weight-bold">التذكير الأول</div>
          <div class="text-h5">{{ stats.firstReminderCount }}</div>
        </v-sheet>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-sheet class="pa-3 bg-red-lighten-4 text-center rounded-lg">
          <div class="font-weight-bold">التذكير الثاني</div>
          <div class="text-h5">{{ stats.secondReminderCount }}</div>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Chart -->
    <v-row>
      <v-col>
    <h4>الاستجابات</h4>

        <v-card class="mt-4 pa-4">
          <BarChart :data="formattedResponseStats" />
        </v-card>
      </v-col>
    </v-row>


    <!-- <v-row class="mt-6">
      <v-col cols="12">
        <h4>تفاصيل الأسئلة والإجابات</h4>

        <v-expansion-panels>
          <v-expansion-panel
            v-for="question in stats.questionsStats"
            :key="question.questionId"
          >
            <v-expansion-panel-title>{{ question.question }}</v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>الإجابة</th>
                    <th>العدد</th>
                    <th>النسبة %</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="answer in question.answers"
                    :key="answer.answer"
                  >
                    <td>{{ answer.answer }}</td>
                    <td>{{ answer.count }}</td>
                    <td>{{ answer.percent }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row> -->


    <!-- <v-row v-for="question in stats.questionsStats" :key="question.questionId">
        <v-col cols="12" md="6">
            <h5>{{ question.question }}</h5>
            <BarChart :data="question.answers.map(a => ({ label: a.answer, value: a.count }))" />
        </v-col>
    </v-row> -->

    <v-row v-for="question in stats.questionsStats" :key="question.questionId">
  <v-col cols="12" md="6">
    <h5>{{ question.question }}</h5>

    <BarChart
      v-if="question.answers.length"
      :data="question.answers.map(a => ({
        label: a.answer + ' [ ' + a.percent + ' % ]',
        value: Number(a.count) || 0
      }))"
      :key="question.questionId + '-chart'"
    />

    <p v-else class="text-grey--text">لا توجد بيانات لعرضها لهذا السؤال.</p>
  </v-col>
</v-row>
    <!-- Export buttons -->
    <v-row class="mt-4 justify-end">
      <v-btn color="primary" @click="exportExcel" class="me-2">تصدير Excel</v-btn>
      <!-- <v-btn color="secondary" @click="exportPDF">تصدير PDF</v-btn> -->
    </v-row>
  </v-card>
</template>

<script>
import BarChart from '../charts/BarChart.vue'; // You create this using Chart.js or vue-chartjs
import * as XLSX from 'xlsx';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
import repository from '@/api/repository';

export default {
  props: ['surveyId'],
  components: {
    BarChart,
  },
  data() {
    return {
      stats: {
        sentCount: 0,
        openedCount: 0,
        firstReminderCount: 0,
        secondReminderCount: 0,
        responseStats: {
          firstMessage: 0,
          firstReminder: 0,
          secondReminder: 0,
          noResponse: 0,
        },
      },
    };
  },
  async mounted() {
    await this.loadStats();
  },
  watch: {
    surveyId() {
        console.log({
            surveyId: this.surveyId
        })
      this.loadStats();
    },
  },
  computed: {
    formattedResponseStats() {
      if (!this.stats || !this.stats.responseStats) return [];
      const rs = this.stats.responseStats;
      return [
        { label: 'الرسالة الأولى', value: rs.firstMessage },
        { label: 'التذكير الأول', value: rs.firstReminder },
        { label: 'التذكير الثاني', value: rs.secondReminder },
        { label: 'لم يستجيبوا', value: rs.noResponse },
      ];
    }
  },
  methods: {
    async loadStats() {
      try {
        // const res = await this.$axios.get(`/api/surveys/${this.surveyId}/statistics`);
        const res = await repository.getSurveyStatistics(this.surveyId);

        this.stats = res.data;
      } catch (err) {
        console.error('Failed to load survey stats', err);
      }
    },
    exportExcel() {
      if (!this.stats) return;

      const wb = XLSX.utils.book_new();

      // --- Sheet 1: الملخص العام ---
      const summaryRows = [
        ['تقرير نتائج واستجابات الاستبيان'],
        [''],
        ['المؤشر', 'العدد'],
        ['تم الإرسال إلى', this.stats.sentCount || 0],
        ['إجمالي عدد الاستجابات', this.stats.openedCount || 0],
        ['استجاب من الرسالة الأولى', this.stats.responseStats?.firstMessage || 0],
        ['استجاب من التذكير الأول', this.stats.responseStats?.firstReminder || 0],
        ['استجاب من التذكير الثاني', this.stats.responseStats?.secondReminder || 0],
        ['لم يستجيبوا', this.stats.responseStats?.noResponse || 0],
        ['التذكير الأول المرسل', this.stats.firstReminderCount || 0],
        ['التذكير الثاني المرسل', this.stats.secondReminderCount || 0],
      ];

      const wsSummary = XLSX.utils.aoa_to_sheet(summaryRows);
      wsSummary['!cols'] = [{ wch: 30 }, { wch: 15 }];
      XLSX.utils.book_append_sheet(wb, wsSummary, 'الملخص العام');

      // --- Sheet 2: تحليل الأسئلة والإجابات ---
      const questionsRows = [
        ['تفاصيل الأسئلة والإجابات'],
        ['']
      ];

      if (Array.isArray(this.stats.questionsStats)) {
        this.stats.questionsStats.forEach((q, idx) => {
          questionsRows.push([`سؤال ${idx + 1}: ${q.question}`, `نوع السؤال: ${q.type || '-'}`]);
          questionsRows.push(['الإجابة / الخيار', 'عدد الاستجابات', 'النسبة المئوية %']);

          if (Array.isArray(q.answers) && q.answers.length > 0) {
            q.answers.forEach((ans) => {
              questionsRows.push([
                ans.answer || '-',
                Number(ans.count) || 0,
                `${ans.percent || '0'}%`
              ]);
            });
          } else {
            questionsRows.push(['لا توجد إجابات مسجلة لهذا السؤال', 0, '0%']);
          }

          questionsRows.push(['إجمالي الاستجابات للسؤال', q.totalResponses || 0, '100%']);
          questionsRows.push(['']); // Blank separator row
        });
      }

      const wsQuestions = XLSX.utils.aoa_to_sheet(questionsRows);
      wsQuestions['!cols'] = [{ wch: 40 }, { wch: 18 }, { wch: 18 }];
      XLSX.utils.book_append_sheet(wb, wsQuestions, 'تحليل الأسئلة');

      // --- Sheet 3: جدول البيانات الشامل ---
      const masterRows = [
        ['رقم السؤال', 'نص السؤال', 'نوع السؤال', 'الإجابة / الخيار', 'عدد الاستجابات', 'النسبة المئوية %']
      ];

      if (Array.isArray(this.stats.questionsStats)) {
        this.stats.questionsStats.forEach((q, idx) => {
          if (Array.isArray(q.answers) && q.answers.length > 0) {
            q.answers.forEach((ans) => {
              masterRows.push([
                idx + 1,
                q.question,
                q.type || 'اختيار',
                ans.answer || '-',
                Number(ans.count) || 0,
                `${ans.percent || '0'}%`
              ]);
            });
          } else {
            masterRows.push([
              idx + 1,
              q.question,
              q.type || 'نص',
              '-',
              0,
              '0%'
            ]);
          }
        });
      }

      const wsMaster = XLSX.utils.aoa_to_sheet(masterRows);
      wsMaster['!cols'] = [{ wch: 12 }, { wch: 35 }, { wch: 15 }, { wch: 30 }, { wch: 15 }, { wch: 15 }];
      XLSX.utils.book_append_sheet(wb, wsMaster, 'البيانات الشاملة');

      // --- Sheet 4: ردود الأشخاص التفصيلية ---
      if (Array.isArray(this.stats.userResponses) && this.stats.userResponses.length > 0) {
        const questionsList = Array.isArray(this.stats.questionsStats) ? this.stats.questionsStats : [];
        const userHeader = ['م', 'اسم المستجيب', 'رقم الهاتف', 'مصدر الاستجابة', 'تاريخ الاستجابة'];
        questionsList.forEach((q, idx) => {
          userHeader.push(`س${idx + 1}: ${q.question}`);
        });

        const userRows = [
          ['سجل استجابات الأشخاص التفصيلية'],
          [''],
          userHeader
        ];

        this.stats.userResponses.forEach((resItem, idx) => {
          const row = [
            idx + 1,
            resItem.userName || 'مستخدم',
            resItem.phoneNumber || '-',
            resItem.source || 'مباشر',
            resItem.respondedAt || '-'
          ];

          questionsList.forEach((q) => {
            const userAnsObj = (resItem.answers || []).find(a => a.questionId === q.questionId);
            row.push(userAnsObj ? userAnsObj.answer : '-');
          });

          userRows.push(row);
        });

        const wsUsers = XLSX.utils.aoa_to_sheet(userRows);
        const colWidths = [{ wch: 6 }, { wch: 25 }, { wch: 18 }, { wch: 18 }, { wch: 22 }];
        questionsList.forEach(() => colWidths.push({ wch: 30 }));
        wsUsers['!cols'] = colWidths;

        XLSX.utils.book_append_sheet(wb, wsUsers, 'ردود المستجيبين');
      }

      const fileName = `تقرير_نتائج_الاستبيان_${new Date().toISOString().slice(0, 10)}.xlsx`;
      XLSX.writeFile(wb, fileName);
    },


    // exportPDF() {
    //   const doc = new jsPDF();
    //   doc.text('إحصائيات الاستبيان', 14, 10);
    //   doc.autoTable({
    //     startY: 20,
    //     head: [['الوصف', 'القيمة']],
    //     body: [
    //       ['تم الإرسال إلى', this.stats.sentCount],
    //       ['عدد الفتحات', this.stats.openedCount],
    //       ['التذكير الأول', this.stats.firstReminderCount],
    //       ['التذكير الثاني', this.stats.secondReminderCount],
    //       ['استجاب من الرسالة الأولى', this.stats.responseStats.firstMessage],
    //       ['استجاب من التذكير الأول', this.stats.responseStats.firstReminder],
    //       ['استجاب من التذكير الثاني', this.stats.responseStats.secondReminder],
    //       ['لم يستجب', this.stats.responseStats.noResponse],
    //     ],
    //   });
    //   doc.save('survey_statistics.pdf');
    // },
  },
};
</script>
